import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
const CreateButton = ({ to, label, col, disabled = false, state }) => {
    return (React.createElement("div", { className: `field col-${col || 6}`, style: { marginLeft: 'auto', display: 'flex', height: 55 } },
        React.createElement(Link, { to: to, state: state, style: { textDecoration: "none", marginLeft: 'auto', display: 'flex', pointerEvents: disabled ? 'none' : 'auto' } },
            React.createElement(Button, { disabled: disabled, label: `Create ${label}` }))));
};
export default CreateButton;
